import * as _ from "lodash";
import {BaseVMeterModalView, BaseVMeterModalViewOptions} from "../_BaseVMeterAppViews";
import {OrganizationCollection} from "../../../../collections/Organizations";
import {UserGroupCollection} from "../../../../collections/UserGroups";
import * as Backbone from "backbone";
import {GenericDeleteModal} from "../../../../views/modals/GenericDeleteModal";
import {VMeterPermissionCollection} from "../../collections/VMeterPermissions";

export class ModifyVMeterGroupModal extends BaseVMeterModalView {
    vMeterGroupId: number;
    template = _.template(require('../../templates/modals/modifyVMeterGroup.html'));

    constructor(options: BaseVMeterModalViewOptions) {
        super(<any> _.extend(options, {
            tagName: 'div',
            events: {
                'shown.bs.modal #addVMeterGroupModal': 'handleModalShown',
                'hidden.bs.modal #addVMeterGroupModal': 'handleModalHidden',
                'change .add-vgroup-modal-app-select': 'handleOrgChange', 
                'change .permission-checkbox': 'handlePermissionChange',
                'click .add-vgroup-btn': 'handleAddButtonClick',

                'click .modify-vgroup-btn': 'handleModifyButtonClick',
                'click .delete-vgroup-btn': 'handleDeleteButtonClick',
                'input .add-vgroup-modal-name': 'handleInputName'
            }
        }));

        // For the base class methods
        this.modalIdSelector = 'addVMeterGroupModal';

        this.options.organizationCollection = new OrganizationCollection(
            this.options.organizationCollection.filter((org) => {
                return Boolean(this.options.appCollection.findWhere({
                    organization_id: org.get('id'),
                    type: 'vmeter',
                    enabled: 1
                }))
            }, this)
        );

        this.vMeterGroupId = this.options.vMeterGroupId;

        this.userGroupCollection = null;
        this.userGroupPermissionsCollections = {};

        this.handleInputName = _.debounce(this.handleInputName.bind(this), 100);
    }

    render() {
        var name = '';
        var appId = null;
        if (this.vMeterGroupId) {
            var db = this.options.vMeterGroupCollection.findWhere({id: this.vMeterGroupId});
            name = db.get('name');
            appId = db.get('app_id');
        }

        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            newVMeterGroup: !this.vMeterGroupId,
            vMeterGroupId: this.vMeterGroupId,
            permissionCollection: this.options.permissionCollection,
            appsCollection: this.options.appCollection,
            name: name,
            appId: appId
        }));

        return this;
    }

    handleOrgChange() {
        var appId = this.$('.add-vgroup-modal-app-select').val();

        var app = this.options.appCollection.findWhere({id: Number(appId)});
        var orgId = app.get('organization_id');

        // Load permissions & render toggle buttons
        $.when(this.loadPermissionsCollections(
            orgId,
            'canViewVMeterGroup',
            'canModifyVMeterGroup',
            'canDeleteVMeterGroup'
        ))
        .then(() => {
            this.$('.add-vgroup-btn').prop('disabled', true);
            this.handleAddButtonDisabledState();
        });
    }

    getNewPermissionCollection(usergroupId) {
        // Override base method in _BaseModifyModal
        return new VMeterPermissionCollection([], {userGroupId: usergroupId});
    }

    show () {
        (<any> this.$('#addVMeterGroupModal')).modal('show');
        this.handleOrgChange();
    }

    handleInputName() {
        this.handleAddButtonDisabledState();
    }

    handleAddButtonDisabledState() {
        var canAssignPerms = false;
        if (this.userGroupCollection) {
            if (this.userGroupCollection.isFetching()) {
                this.$('.add-vgroup-btn').prop('disabled', true);
                this.$('.modify-vgroup-btn').prop('disabled', true);
                return;
            }

            // Only allow a new virtual meter group to be created if the user can assign permissions
            this.userGroupCollection.each((group) => {
                if (this.options.permissionCollection.canModifyUserGroupPermissions(group.get('id'))) canAssignPerms = true;
            }, this)
        }

        // Make sure the virtual meter group is named
        if (!this.$('.add-vgroup-modal-name').val() || !canAssignPerms) {
            this.$('.add-vgroup-btn').prop('disabled', true);
            this.$('.modify-vgroup-btn').prop('disabled', true);
            return;
        }

        // Make sure at least one virtual meter group has all permissions
        var allPerms = _.some(this.$('.permission-modify').map(function () {
            return $(this).is(':checked')
        }));
        this.$('.add-vgroup-btn').prop('disabled', !allPerms);
        this.$('.modify-vgroup-btn').prop('disabled', !allPerms);
    }

    handleModifyButtonClick() {
        this.setFormSubmitted();

        $.ajax({
            type: "PUT",
            url: this.options.vMeterGroupCollection.url() + '/' + this.vMeterGroupId,
            data: JSON.stringify({
                appId: Number(this.$('.add-vgroup-modal-app-select').val()),
                name: this.$('.add-vgroup-modal-name').val(),
                permissions: this.getPermissionsDict()
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: () => {
                this.refetchCollectionsAndShow(this.vMeterGroupId)
            }
        });
    }

    handleDeleteButtonClick() {
        var vgroup = this.options.vMeterGroupCollection.findWhere({id: this.vMeterGroupId});

        var modal = new GenericDeleteModal({
            type: 'Virtual Meter Group',
            name: vgroup.get('name'),
            func: () => {
                this.setFormSubmitted();
                return $.when(vgroup.destroy()).done(() => {
                    this.refetchCollectionsAndShow();
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    handleAddButtonClick() {
        this.setFormSubmitted();
        console.log(this.options.vMeterGroupCollection.url())
        $.ajax({
            type: "POST",
            url: this.options.vMeterGroupCollection.url(),
            data: JSON.stringify({
                appId: Number(this.$('.add-vgroup-modal-app-select').val()),
                name: this.$('.add-vgroup-modal-name').val(),
                permissions: this.getPermissionsDict()
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.refetchCollectionsAndShow(response.vMeterGroupId)
            }
        });
    }

    refetchCollectionsAndShow(vMeterGroupId?) {
        var d1 = this.options.vMeterGroupCollection.fetch({reset: true});
        var d2 = this.options.permissionCollection.fetch({reset: true});

        $.when(d1, d2).done(() => {
            this.hide();
            if (!vMeterGroupId || vMeterGroupId !== this.vMeterGroupId) {
                window.location.hash = "#/vmeter" + (vMeterGroupId ? '/' + vMeterGroupId : '');
            } else {
                // Somewhat of a hack to refresh the page
                // See http://stackoverflow.com/questions/8901574/how-to-refresh-a-page-in-a-backbone-application
                Backbone.history.loadUrl();
            }

            window['App'].Bus.trigger('navigation:update');
        }).fail(() => {
            this.setFormError();
        })
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/vmeter/views/modals/ModifyVMeterGroup.ts